'use client';

import { useRouter } from 'next/navigation';
import { Card, Col, Image } from 'react-bootstrap';

export default function ItemVenueMobile({ data = [] }) {
  const router = useRouter();

  return (
    <>
      {data.map((item, index) => (
        <Col lg={4}
          className={`item-venue item-venue-${item.path} p-0`}
          onClick={() => router.push(`/${item.path}`)}
          key={index}
          style={{ cursor: 'pointer' }}
        >
          <Image src='/assets/images/bg_btn_venue.png'/>
          <Image src={item.image} alt={item.title} fluid className='img-venue'/>
        </Col>
      ))}
    </>
  );
}
